import { render, staticRenderFns } from "./plmChangeImpact.vue?vue&type=template&id=a9ebbd5a&scoped=true"
import script from "./plmChangeImpact.vue?vue&type=script&lang=js"
export * from "./plmChangeImpact.vue?vue&type=script&lang=js"
import style0 from "./plmChangeImpact.vue?vue&type=style&index=0&id=a9ebbd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ebbd5a",
  null
  
)

export default component.exports